module.exports = __webpack_public_path__ + "static/media/1013937.ef8ff2d1.jpg";